<template>
  <article class="footer-share">
    <div class="footer-share__share-fb" @click="gafb()">
      <div
        class="fb-like"
        :data-href="getfburl"
        data-layout="button_count"
        data-action="like"
        data-size="small"
        data-share="true"
      >
      </div>
    </div>
    <div class="footer-share__share-linex">
      <a
          :href="shareLineUrl"
          :target="target"
          rel="noopener"
          aria-label="share-line"
          name="share-line"
      >
        <img class="comment_line_image" src="https://p3.udn.com.tw/wish/images/common/btn_LINE_footer.svg" width="84" height="20" alt="LINE分享給朋友" @click="galine()" />
      </a>
    </div>
    <div class="footer-share__share-twitter">
      <a
        :href="shareTwitterUrl"
        target="_blank"
        data-show-count="false"
        aria-label="share-twitter"
        name="share-twitter"
      >
        <img src="https://p3.udn.com.tw/wish/images/common/btn_TWITTER_footer.png" width="60" height="20" alt="TWITTER分享給朋友" @click="gatwitter()" />
      </a>
    </div>
  </article>
</template>

<script>
  import Utils from '@/assets/js/utils/udn-newmedia-utils'
  import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
  const isMobile = Utils.detectMob();
  const isInApp = Utils.isFacebookApp(148) || Utils.isLineApp();
  export default {
    mixins: [sendGaMethods],
    data(){
        return{
          href:"https://udn70.udn.com/wish/",
        }
    },
    // created () {
    //     window.addEventListener('load', this.loadevent);
    // },
    // destroyed () {
    //     window.removeEventListener('load', this.loadevent);
    // },
    mounted(){
      window.FB.XFBML.parse();
    },
    methods:{
      // loadevent(){
        
      //   window.FB.XFBML.parse();
      // }
      gafb(){
        this.sendGA(this.formatGA('FooterFbShare'));
      },
      galine(){
        this.sendGA(this.formatGA('FooterLineShare'));
      },
      gatwitter(){
        this.sendGA(this.formatGA('FooterTwitterShare'));
      }
    },
    computed: {
      getfburl(){
        return this.href+this.$route.path.split('/').reverse()[0];
      },
      shareLineUrl() {
        if (!isMobile) {
            return `https://social-plugins.line.me/lineit/share?text=${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}&url=${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
        }
        // mobile
        if (!isInApp) {
            return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
        }
        // mobile in-app webview
        return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
      },
      shareTwitterUrl() {
        return `https://twitter.com/intent/tweet?text=${encodeURIComponent(document.querySelector('meta[name="twitter:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[name="twitter:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`;
      },
      target() {
          if (!isMobile) return '_blank';
          return '_self';
      },
    },
  }
</script>


<style lang="scss" scoped>
.footer-share {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 80px 0;

  .footer-share__share-fb {
    margin: 5px -10px 0 0;
    //margin-right: 8px;
  }
  .footer-share__share-line {
    a {
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
  }
  .footer-share__share-twitter {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: 8px;
    margin-bottom: 3px;
    a {
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
  }
}
    
</style>